import { useState } from 'react';
import { ShieldAlert, Eraser } from '../../lib/icons';
import { toast } from 'sonner';
import { useAuth } from '../../lib/auth';
import { verifierMotDePasse } from '../../lib/utilisateurs';
import { etatPropre } from '../../lib/dataProvider';
import { reinitialiserPropre } from '../../lib/store';

const CONSERVE = ['Contacts & fournisseurs (intouchables)', 'Catalogue produits & formats', 'Tarifs & souches', 'Utilisateurs & droits', 'Logo & paramètres', 'Cuves (remises à 0 kg)'];
const EFFACE = ['Réceptions & lots', 'Ventes & factures', 'Caisses (soldes à 0)', 'Pointages & paie', 'Sous-produits & OF', 'Journal d’audit'];

export const ReinitialisationDialog = ({ onClose }) => {
  const { user } = useAuth();
  const [mdp, setMdp] = useState('');
  const [enCours, setEnCours] = useState(false);

  const confirmer = async (e) => {
    e.preventDefault();
    const confirme = await verifierMotDePasse(mdp);
    if (!confirme) return toast.error('Mot de passe administrateur incorrect.');
    setEnCours(true);
    try {
      const r = await reinitialiserPropre(etatPropre());
      toast.success(`Base réinitialisée — sauvegarde de sécurité ${r.sauvegarde} créée. Rechargement…`);
      setTimeout(() => window.location.reload(), 1200);
    } catch (err) {
      toast.error(err.message);
      setEnCours(false);
    }
  };

  return (
    <div data-testid="reinit-overlay" className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/60 p-4">
      <form onSubmit={confirmer} data-testid="reinit-form" className="w-full max-w-lg border border-slate-200 border-t-4 border-t-red-600 bg-white">
        <div className="border-b border-slate-200 px-5 py-4">
          <h2 className="flex items-center gap-2 font-heading text-lg font-black tracking-tight text-slate-900">
            <ShieldAlert size={18} className="text-red-600" /> Réinitialisation propre de l’ERP
          </h2>
          <p className="text-xs text-slate-500">
            Une sauvegarde de sécurité est créée automatiquement avant l’effacement — restaurable depuis le panneau Sauvegardes.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 px-5 py-4">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.1em] text-emerald-700">Conservé</p>
            <ul className="mt-1 space-y-0.5 font-data text-xs text-slate-700">
              {CONSERVE.map((x) => <li key={x}>· {x}</li>)}
            </ul>
          </div>
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.1em] text-red-700">Effacé</p>
            <ul className="mt-1 space-y-0.5 font-data text-xs text-slate-700">
              {EFFACE.map((x) => <li key={x}>· {x}</li>)}
            </ul>
          </div>
        </div>
        <div className="px-5 pb-4">
          <label className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500">
            Mot de passe de {user?.name ?? 'l’administrateur'} pour confirmer
          </label>
          <input
            data-testid="reinit-mdp"
            type="password"
            autoFocus
            value={mdp}
            onChange={(e) => setMdp(e.target.value)}
            className="mt-1.5 h-11 w-full border border-slate-300 bg-slate-50 px-3 font-data text-sm outline-none focus:border-red-600 focus:bg-white"
          />
        </div>
        <div className="flex gap-3 border-t border-slate-200 px-5 py-4">
          <button
            type="submit"
            data-testid="reinit-confirmer"
            disabled={!mdp || enCours}
            className="flex h-11 flex-1 items-center justify-center gap-2 bg-red-600 font-heading text-sm font-bold uppercase tracking-[0.08em] text-white transition-colors duration-150 hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300"
          >
            <Eraser size={15} /> {enCours ? 'Réinitialisation…' : 'Vider les données courantes'}
          </button>
          <button type="button" data-testid="reinit-annuler" onClick={onClose} className="h-11 border border-slate-300 px-5 text-sm font-semibold text-slate-700 transition-colors duration-150 hover:bg-slate-100">
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
};
